import {IsoDate} from "../../pseudo-types/DateTypes";
import {CodeAndExchange} from "../../instruments/types/CodeAndExchange";

export interface OrderConditions {
    readonly condition: Condition;
    readonly expiry: IsoDate | null;
    readonly price: number;
    readonly priceBase: PriceBase;
    readonly security: CodeAndExchange;
}

export enum PriceBase {
    LAST = "LAST",
    BID = "BID",
    ASK = "ASK"
}

export enum Condition {
    GREATER = "GREATER",
    LESS = "LESS",
    GREATER_OR_EQUAL = "GREATER_OR_EQUAL",
    LESS_OR_EQUAL = "LESS_OR_EQUAL"
}

export function isNotEmpty(conditions: OrderConditions): boolean {
    return (conditions.condition != null) ||
        (conditions.expiry != null) ||
        (conditions.price != null) ||
        (conditions.priceBase != null) ||
        (conditions.security != null);
}
